import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';

import { PresetType } from './preset-token';
import { PresetService } from './preset.service';
import { provideComponents, providePresetFor } from './provide';
export class PresetDefaultModule {
/**
 * @param {?} component
 * @param {?} presetType
 * @return {?}
 */
static forComponent(
    component: Type<any>,
    presetType: Type<PresetType>,
  ): ModuleWithProviders {
    return PresetDefaultModule.forComponents([component], presetType);
  }
/**
 * @param {?} components
 * @param {?} presetType
 * @return {?}
 */
static forComponents(
    components: Type<any>[],
    presetType: Type<PresetType>,
  ): ModuleWithProviders {
    return providePresetFor(
      PresetDefaultModule,
      presetType,
      provideComponents(components),
    );
  }
/**
 * @param {?} presetService
 */
constructor(presetService: PresetService) {
    presetService.initDecoratedPresets();
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  exports: [],
  declarations: [],
  providers: [PresetService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PresetService, },
];
}

function PresetDefaultModule_tsickle_Closure_declarations() {
/** @type {?} */
PresetDefaultModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PresetDefaultModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
